import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as DownstreamOwnerIdsFilteredByFieldQuery
export const DownstreamOwnersFilteredByFieldQueryGql: DocumentNode = gql`
query DownstreamOwnersFilteredByFieldQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...OwnersDisplayGridRowDataFragment
        }
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
